import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";
import { useSelector } from "react-redux";
import { State } from "../../store";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootItem: {
      marginTop: 40,
      paddingLeft: 0,
      width: "100%",
      textAlign: "center",
      color: "#fff",
      backgroundColor: theme.palette.secondary.light,
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    primaryText: {
      fontSize: 15,
      fontWeight: "bold",
      letterSpacing: 1,
    },
    secondaryText: {
      fontSize: 13,
      fontWeight: "bold",
      letterSpacing: 0.5,
      color: "#fff",
      marginTop: 4,
      wordBreak: "break-word",
    },
  })
);

const LoginInfo: React.FC = () => {
  const classes = useStyles();
  const { webUser } = useSelector((state: State) => state.auth);
  return (
    <Link onClick={() => {}} component={"li"} style={{ textDecoration: "none" }}>
      <ListItem button classes={{ root: classes.rootItem }}>
        <ListItemText
          classes={{ primary: classes.primaryText, secondary: classes.secondaryText }}
          primary={"Zalogowany:"}
          secondary={webUser.email}
        />
      </ListItem>
      <Divider />
    </Link>
  );
};

export default LoginInfo;
